import { Button, Modal, Typography } from "@/components/atoms";

interface WarningAffectVerificationModalProps {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
}

export const WarningAffectVerificationModal = ({ open, onClose, onContinue }: WarningAffectVerificationModalProps) => {
  return (
    <Modal open={open} onClose={onClose} className="w-[85vw] !p-6 md:w-[450px]">
      <div className="flex flex-col">
        <Typography variant="title">Changing Vehicle Details Will Affect Verification</Typography>
        <Typography variant="paragraph" className="mt-3 text-neutral-dark-gray">
          Updating the plate number or state of registration will temporarily make this vehicle unverified.
        </Typography>
        <Typography variant="paragraph" className="mt-3 text-neutral-dark-gray">
          You&apos;ll need to reverify the vehicle after saving the new details, which includes a reverification fee.
        </Typography>
        <div className="mt-6 flex justify-end gap-3">
          <Button variant="secondary" size="md" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" size="md" onClick={onContinue}>
            Continue
          </Button>
        </div>
      </div>
    </Modal>
  );
};
